import type { ApolloError } from '@apollo/client/core'

// Splits one noisy "Failed to fetch availability" Sentry error into three real ones: network,
// HTTP, and GraphQL. Messages stay generic so Sentry still groups repeats instead of scattering them.

export class NetworkFetchError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = 'NetworkFetchError'
  }
}

export class HttpFetchError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = 'HttpFetchError'
  }
}

export class GraphQLFetchError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = 'GraphQLFetchError'
  }
}

export function throwClassifiedFetchError(prefix: string, error: ApolloError): never {
  const { networkError, graphQLErrors } = error

  if (networkError && 'statusCode' in networkError) {
    throw new HttpFetchError(`${prefix}: HTTP ${networkError.statusCode}`, { cause: error })
  }

  if (networkError) {
    throw new NetworkFetchError(`${prefix}: network error`, { cause: error })
  }

  if (graphQLErrors?.length) {
    throw new GraphQLFetchError(`${prefix}: GraphQL error`, { cause: error })
  }

  throw new Error(`${prefix}: unknown error`, { cause: error })
}
